import script from "./storagePayDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./storagePayDetail.vue?vue&type=script&setup=true&lang=js"

import "./storagePayDetail.vue?vue&type=style&index=0&id=7ce9b7eb&lang=less"

const __exports__ = script;

export default __exports__